import {combine, forward, merge, sample} from 'effector';

import {RestError, showRestError} from 'core/errors';
import {mapFilters} from 'utils/filters';

import {
    pageNumber$,
    pageNumberChanged,
    fetchDataFx,
    filtersChanged,
    data$,
    filters$,
    sorting$,
    sortingChanged,
    Gate,
    pageIncremented,
    pageSize$,
} from './index';

data$
    .on(fetchDataFx.done, (state, {result}) => ({
        content: state ? state.content.concat(result.content) : result.content,
        total: result.totalPages,
    }))
    .reset(sortingChanged, filtersChanged, Gate.close);
pageNumber$.reset(Gate.close);
pageSize$.reset(Gate.close);
sorting$.reset(Gate.close);
filters$.reset(Gate.close);

forward({from: sortingChanged.map(() => 0), to: pageNumberChanged});
forward({from: filtersChanged.map(() => 0), to: pageNumberChanged});

sample({
    clock: pageIncremented,
    source: pageNumber$.map((state) => state + 1),
    target: pageNumberChanged,
});

sample({
    clock: merge([Gate.open, pageNumberChanged]),
    source: combine({
        sorting: sorting$,
        filters: filters$,
        pageNumber: pageNumber$,
        pageSize: pageSize$,
    }),
    fn: ({pageNumber, pageSize, filters, sorting}) => ({
        pageNumber,
        pageSize,
        filters: mapFilters(filters),
        sortings: sorting,
    }),
    target: fetchDataFx,
});

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));
